<template>
  <div class="phone_home w-100">
    <div class="home-top">
      <div class="home-swiper-wrapper">
        <Swiper :listImg="listImg"/>
      </div>
      <EmailFacebook />
      <PhoneGoKS  />
      <VideoBox />
      <Prologue />

      <vue-lazy-component tagName="div" :timeout="1000">
        <EboX />
        <div class="home-Progress1-img">
          <ProgressImg :srcUrl="ProgressImg1" />
        </div>
        <WhyEboX :isHome="false" />
      </vue-lazy-component>

      <vue-lazy-component tagName="div" :timeout="2000">
        <div class="home-Progress2-img">
          <ProgressImg :srcUrl="ProgressImg2" />
        </div>
        <Charter1 />
        <div class="margin-top-rem">
          <SmarterMapping />
        </div>
        <SelfBalancedTwoWheeledDesign />
        <StablizedCamera />
        <EdgeDetection />
        <AutoBackToCharge />
        <FixedLocation />
        <ElderlyFallAlert />
        <CryingCallForHelpAlert />
        <CertainAreasIntrusionAlert />
        <FacialRecognition />
      </vue-lazy-component>
      
      <vue-lazy-component tagName="div" :timeout="4000">
        <div class="home-Progress3-img">
          <ProgressImg :srcUrl="ProgressImg3" />
        </div>
        <Charter2 />
        <div class="margin-top-rem">
          <EboHomeApp />
        </div>
        <RealTimeTwoWay />
        <LeavingVoiceMessage />
        <MultipleLogin />
        <ColorNightVisior />
        <SoundSourceLocation />
        <SmartTrackingTwo />
        <SmartPersonalAssistant />
        <ThePerfectPet />
      </vue-lazy-component>
      <vue-lazy-component tagName="div" :timeout="5000">
        <div class="home-Progress3-img">
          <ProgressImg :srcUrl="ProgressImg4" />
        </div>
        <Charter3 />
        <div class="margin-top-rem">
          <ThreeControlModes />
        </div>

        <HarmanAudioEFX />
        <BringAlexaToYou />
        <PhotoVideo />
        <RichLightingColor />
      </vue-lazy-component>
      <vue-lazy-component tagName="div" :timeout="6000">
        <div class="home-Progress4-img">
          <ProgressImg :srcUrl="ProgressImg5" />
        </div>
        <Charter4 />
        <FooterThree />
        <div class="FooterSubscribe-wrap">
          <FooterSubscribe @handleStatus="handleStatus" :tag="['ebo_x_home']" />
        </div>
      </vue-lazy-component>
    </div>
    <transition name="fade-transform" mode="out-in">
      <!-- <Totas :class="[showtatos ?'show-tatos-active':'show-tatos']" :status="status" @handleClose="handleClose" /> -->
      <Totas v-show="showtatos" :status="status" @handleClose="handleClose" />
    </transition>
    
  </div>
</template>

<script>
import Totas from "@/components/totas";
/* *********** */
import Swiper from './components/swiper.vue'
// import SubscribeEmail from './components/subscribeEmail.vue'
import PhoneGoKS from './components/phoneGoKS'
import VideoBox from './components/videoBox.vue'
import Prologue from './components/prologue.vue'
import EboX from './components/eboX.vue'
import ProgressImg from './components/progressImg.vue'
import WhyEboX from './components/whyEboX.vue'
import Charter1 from './components/charter1.vue'
import SmarterMapping from './components/smarterMapping.vue'
import SelfBalancedTwoWheeledDesign from './components/selfBalancedTwoWheeledDesign.vue'
import StablizedCamera from './components/stablizedCamera.vue'
import EdgeDetection from './components/edgeDetection.vue'
import AutoBackToCharge from './components/autoBackToCharge.vue'
import FixedLocation from './components/fixedLocation.vue'
import ElderlyFallAlert from './components/elderlyFallAlert.vue'
import CryingCallForHelpAlert from './components/cryingCallForHelpAlert.vue'
import CertainAreasIntrusionAlert from './components/certainAreasIntrusionAlert.vue'
import FacialRecognition from './components/facialRecognition.vue'
import Charter2 from './components/charter2.vue'
import EboHomeApp from './components/eboHomeApp.vue'
import RealTimeTwoWay from './components/realTimeTwoWay.vue'
import LeavingVoiceMessage from './components/leavingVoiceMessage.vue'
import MultipleLogin from './components/multipleLogin.vue'
import ColorNightVisior from './components/colorNightVisior.vue'
import SoundSourceLocation from './components/soundSourceLocation.vue'
import SmartTrackingTwo from './components/smartTracking2.vue'
import SmartPersonalAssistant from './components/smartPersonalAssistant.vue'
import ThePerfectPet from './components/thePerfectPet.vue'
import Charter3 from './components/charter3.vue'
import ThreeControlModes from './components/threeControlModes.vue'
import HarmanAudioEFX from './components/harmanAudioEFX.vue'
import BringAlexaToYou from './components/bringAlexaToYou.vue'
import PhotoVideo from './components/photoVideo.vue'
import RichLightingColor from './components/richLightingColor.vue'
import Charter4 from './components/charter4.vue'
import FooterThree from './components/footerThree.vue'
import FooterSubscribe from './components/footerSubscribe.vue'
import EmailFacebook from './components/emailFacebook.vue'
// import Test1 from '@/components/test1.vue'

export default {
  name: 'Home',
  components: {
    Totas,
    Swiper,
    PhoneGoKS,
    VideoBox,
    Prologue,
    EboX,
    ProgressImg,
    WhyEboX,
    Charter1,
    SmarterMapping,
    SelfBalancedTwoWheeledDesign,
    StablizedCamera,
    EdgeDetection,
    AutoBackToCharge,
    FixedLocation,
    ElderlyFallAlert,
    CryingCallForHelpAlert,
    CertainAreasIntrusionAlert,
    FacialRecognition,
    Charter2,
    EboHomeApp,
    RealTimeTwoWay,
    LeavingVoiceMessage,
    MultipleLogin,
    ColorNightVisior,
    SoundSourceLocation,
    SmartTrackingTwo,
    SmartPersonalAssistant,
    ThePerfectPet,
    Charter3,
    ThreeControlModes,
    HarmanAudioEFX,
    BringAlexaToYou,
    PhotoVideo,
    RichLightingColor,
    Charter4,
    FooterThree,
    FooterSubscribe,
    EmailFacebook
  },
  data() {
    return {
      listImg:[
        {
          img:'https://mediakit.enabot.com/eboX/img/mobile/banner1.png'
        },
        {
          img:'https://mediakit.enabot.com/eboX/img/mobile/banner2.png'
        },
        {
          img:'https://mediakit.enabot.com/eboX/img/mobile/banner4.png'
        }
      ],
      // ProgressImg1: require("https://mediakit.enabot.com/eboX/img/mobile/progress1@2x.png"),
      // ProgressImg2: require("https://mediakit.enabot.com/eboX/img/mobile/progress2@2x.png"),
      // ProgressImg3: require("https://mediakit.enabot.com/eboX/img/mobile/progress3@2x.png"),
      // ProgressImg4: require("https://mediakit.enabot.com/eboX/img/mobile/progress4@2x.png"),
      ProgressImg1: "https://mediakit.enabot.com/eboX/gif/progress_common_gif.gif",
      ProgressImg2: "https://mediakit.enabot.com/eboX/gif/progress_common_gif.gif",
      ProgressImg3: "https://mediakit.enabot.com/eboX/gif/progress_common_gif.gif",
      ProgressImg4: "https://mediakit.enabot.com/eboX/gif/progress_common_gif.gif",
      ProgressImg5: "https://mediakit.enabot.com/eboX/gif/progress_common_gif.gif",
      showtatos:false,
      status:1,
    }
  },
  mounted() {
    
  },
  methods: {
    handleClose() {
      this.showtatos = false
    },
    handleStatus(data) {
      this.status = data.status
      setTimeout(()=>{this.showtatos = true},200)
    }
  },
}
</script>

<style lang="scss">
.phone_home{
  width: 100%;
  background-color: rgb(4, 13, 50);
  overflow: hidden;
  transform:translateZ(0deg);
  .home-Progress1-img{
    padding: 3rem 0;
  }
  .home-Progress2-img{
    padding: 2.125rem 0 1rem 0;
  }
  .home-Progress3-img{
    padding-bottom: 2.125rem;
  }
  .show-tatos{
    opacity: 0;
    // display: none;
  }
  .show-tatos-active{
    opacity: 1;
    // display: block;
  }
  .FooterSubscribe-wrap{
    padding-bottom: 3.375rem;
  }
  .margin-top-rem{
    margin-top: -3.1rem;
  }
}
@media screen and (min-width: 375px) {
  html {
      /* iPhone6的375px尺寸作为16px基准，414px正好18px大小, 600 20px */
      font-size: calc(100% + 2 * (100vw - 375px) / 39);
      font-size: calc(16px + 2 * (100vw - 375px) / 39);
  }
}
@media screen and (min-width: 414px) {
  html {
      /* 414px-1000px每100像素宽字体增加1px(18px-22px) */
      font-size: calc(112.5% + 4 * (100vw - 414px) / 586);
      font-size: calc(18px + 4 * (100vw - 414px) / 586);
  }
}
@media screen and (min-width: 600px) {
  html {
      /* 600px-1000px每100像素宽字体增加1px(20px-24px) */
      font-size: calc(125% + 4 * (100vw - 600px) / 400);
      font-size: calc(20px + 4 * (100vw - 600px) / 400);
  }
}
</style>
